import React from "react";
//import FibreProsSection from "@/component/fibre-pros-section";
import FibreProsSection from "@/bit/components/components.fibre-pros-section";
import ServiceCard from "@/component/service-card";
import FaqsCompo from "@/component/faqs";
import InteresCard from "@/component/interest-card";
import SafeBoxCard from "@/component/safebox-card";
import CustomizerComponent from "@/bit/components/components.customizer-component";
import Devices from "@/component/devices-offers";

const filePath = "layout/fichas.js";

/**
 * @name Layout
 * @description Connectivity page layout
 * @param {any} props
 * @returns {React.FC}
 */
export default function Layout(props) {
  const { custoInfo } = props;
  return (
    <>
      <br></br>
      <main>
        {props["MODULO_CARDS"] && (
          <ServiceCard orionInfo={props["MODULO_CARDS"]} />
        )}
        {props["MODULO_CARDS_FINANZAS"] && (
          <InteresCard {...props["MODULO_CARDS_FINANZAS"]} />
        )}
        {props["LISTADO_CARACTERISTICAS_ICONO_TITULO_DESCRIPCION"] &&
          props["LISTADO_PASOS_ICONO_TITULO_DESCRIPCION"] && (
            <FibreProsSection
              sectionLeft={
                props["LISTADO_CARACTERISTICAS_ICONO_TITULO_DESCRIPCION"]
              }
              sectionRight={props["LISTADO_PASOS_ICONO_TITULO_DESCRIPCION"]}
            />
          )}
        {props["LISTADO_CARACTERISTICAS_ICONO_TITULO_DESCRIPCION"] &&
          props["LISTADO_CARACTERISTICAS_ICONO_TITULO_DESCRIPCION_02"] && (
            <FibreProsSection
              sectionLeft={
                props["LISTADO_CARACTERISTICAS_ICONO_TITULO_DESCRIPCION"]
              }
              sectionRight={
                props["LISTADO_CARACTERISTICAS_ICONO_TITULO_DESCRIPCION_02"]
              }
            />
          )}
        {props["LISTADO_PASOS_ICONO_TITULO_DESCRIPCION"] &&
          props["LISTADO_PASOS_ICONO_TITULO_DESCRIPCION_02"] && (
            <FibreProsSection
              sectionLeft={props["LISTADO_PASOS_ICONO_TITULO_DESCRIPCION"]}
              sectionRight={props["LISTADO_PASOS_ICONO_TITULO_DESCRIPCION_02"]}
            />
          )}

        {props["MODULO_VENTA_CRUZADA_OTROS_SERVICIOS"] && (
          <InteresCard {...props["MODULO_VENTA_CRUZADA_OTROS_SERVICIOS"]} />
        )}

        {props["MODULO_CARDS_VENTA_CRUZADA"] && (
          <SafeBoxCard {...props["MODULO_CARDS_VENTA_CRUZADA"]} />
        )}
        
        {props["COMPONENT_TYPE"] && props["COMPONENT_TYPE"].activityId && custoInfo && (
          <CustomizerComponent
            name={props["COMPONENT_TYPE"].activityId}
            Component={Devices}
            componentName="devicesSection"
            componentProps={custoInfo[props["COMPONENT_TYPE"].activityId]}
          />
        )}

        {props["FAQS_PREGUNTAS_FRECUENTES"] && (
          <FaqsCompo {...props["FAQS_PREGUNTAS_FRECUENTES"]} />
        )}
      </main>
    </>
  );
}
